module.exports = "../images/fishing-lodge-19.jpg?v=6e0456c";